module.exports = __webpack_public_path__ + "static/media/laowumianshi1.8c8a033f.png";